interface GetTabItemValueProps extends Partial<HTMLElement> {
  href?: string;
  value?: string;
}

export function getTabItemValue(obj?: GetTabItemValueProps) {
  if (!obj) {
    return null;
  }
  if (obj.href) {
    if (obj.getAttribute) {
      return obj.getAttribute('href');
    }
    return obj.href;
  }

  return obj.value;
}
